const customerList = () => import('@/views/main/customer/list/list.vue')
export default {
  path: '/main/customer/list',
  name: 'customerList',
  component: customerList,
  children: []
}
